import { ACTIONS } from '../actions';
import { pluginKey as typeAheadPluginKey } from '../key';
export var updateListItem = function updateListItem(items) {
  return function (state, dispatch) {
    var tr = state.tr;
    tr.setMeta(typeAheadPluginKey, {
      action: ACTIONS.UPDATE_LIST_ITEMS,
      params: {
        items: items
      }
    });
    if (dispatch) {
      dispatch(tr);
    }
    return true;
  };
};